export const states = [
  "Abia",
  "Adamawa",
  "Akwa Ibom",
  "Anambra",
  "Bauchi",
  "Bayelsa",
  "Benue",
  "Borno",
  "Cross River",
  "Delta",
  "Ebonyi",
  "Edo",
  "Ekiti",
  "Enugu",
  "FCT - Abuja",
  "Gombe",
  "Imo",
  "Jigawa",
  "Kaduna",
  "Kano",
  "Katsina",
  "Kebbi",
  "Kogi",
  "Kwara",
  "Lagos",
  "Nasarawa",
  "Niger",
  "Ogun",
  "Ondo",
  "Osun",
  "Oyo",
  "Plateau",
  "Rivers",
  "Sokoto",
  "Taraba",
  "Yobe",
  "Zamfara",
];

export const countries = [
  "Thailand",
  "France",
  "Bolivia",
  "Peru",
  "Argentina",
  "China",
  "Russia",
  "Indonesia",
  "Eritrea",
  "Mauritania",
  "Japan",
  "Brazil",
  "South Africa",
  "Ireland",
  "Saudi Arabia",
  "Poland",
  "Netherlands",
  "Zimbabwe",
  "Egypt",
  "Portugal",
  "French Polynesia",
  "Albania",
  "Niger",
  "Palestinian Territory",
  "Colombia",
  "Greece",
  "Czech Republic",
  "Philippines",
  "United States",
  "Guatemala",
  "Sweden",
  "Ukraine",
  "Macedonia",
  "Moldova",
  "Lithuania",
  "Vietnam",
  "Paraguay",
  "Croatia",
  "Canada",
  "Uganda",
  "Myanmar",
  "Nicaragua",
  "Iran",
  "Somalia",
  "Angola",
  "Finland",
  "Lesotho",
  "Mexico",
  "Cuba",
  "Tanzania",
  "Pakistan",
  "Israel",
  "Hungary",
  "Malaysia",
  "Nigeria",
  "Estonia",
  "Chile",
  "Norway",
  "Slovenia",
  "Azerbaijan",
  "Ecuador",
  "Democratic Republic of the Congo",
  "Mongolia",
  "Armenia",
  "Kosovo",
  "Spain",
  "Costa Rica",
  "Lebanon",
  "Kenya",
  "United Kingdom",
  "Panama",
  "Benin",
  "Luxembourg",
  "Morocco",
  "Yemen",
  "Ivory Coast",
  "Tunisia",
  "Kuwait",
  "Turkey",
  "Sri Lanka",
  "North Korea",
  "Dominican Republic",
  "Honduras",
  "Jamaica",
  "Turkmenistan",
  "Bangladesh",
  "Serbia",
  "Latvia",
  "Uzbekistan",
  "Bahrain",
  "Comoros",
  "Burkina Faso",
  "Venezuela",
  "Denmark",
  "Bosnia and Herzegovina",
  "Kazakhstan",
  "Nepal",
  "Afghanistan",
  "Iraq",
  "Swaziland",
  "Namibia",
  "Syria",
  "Madagascar",
  "Gabon",
  "Bulgaria",
  "Australia",
  "Chad",
  "Micronesia",
  "Andorra",
  "Switzerland",
  "United Arab Emirates",
  "Uruguay",
  "South Korea",
  "Gambia",
  "Mali",
  "Jordan",
  "Samoa",
  "Zambia",
  "Cameroon",
  "Cambodia",
  "Belarus",
  "Georgia",
  "New Zealand",
  "Togo",
  "Guadeloupe",
  "Tajikistan",
  "South Georgia and the South Sandwich Islands",
  "Germany",
  "Tuvalu",
  "Iceland",
  "Cyprus",
  "Austria",
  "Papua New Guinea",
  "Dominica",
  "Sierra Leone",
  "Libya",
  "Ghana",
  "Laos",
  "Haiti",
  "Oman",
  "Djibouti",
  "Faroe Islands",
  "Saint Kitts and Nevis",
  "Mauritius",
  "Malta",
  "New Caledonia",
  "Central African Republic",
  "Barbados",
  "Bhutan",
  "Pitcairn",
  "Maldives",
  "Guinea",
  "Kyrgyzstan",
  "Botswana",
  "American Samoa",
  "Ethiopia",
  "Guyana",
  "Trinidad and Tobago",
  "Saint Helena",
  "Rwanda",
  "Bonaire",
  "Belgium",
  "El Salvador",
  "Brunei",
  "Mozambique",
  "Bermuda",
  "Burundi",
  "Montenegro",
  "Sudan",
  "Qatar",
  "Liechtenstein",
  "Tokelau",
  "Belize",
  "Liberia",
  "Aruba",
  "Senegal",
  "Cayman Islands",
  "San Marino",
  "Solomon Islands",
  "Marshall Islands",
  "Mayotte",
  "Italy",
  "Taiwan",
  "Guam",
  "Reunion",
  "India",
  "Guinea-Bissau",
  "Saint Vincent and the Grenadines",
  "Hong Kong",
  "Palau",
  "East Timor",
  "Aland Islands",
  "Republic of the Congo",
  "Equatorial Guinea",
  "Malawi",
  "Vanuatu",
  "French Southern Territories",
  "Cape Verde",
  "Martinique",
  "Montserrat",
  "South Sudan",
  "Kiribati",
  "Saint Barthelemy",
  "Bahamas",
  "Greenland",
  "Tonga",
  "Falkland Islands",
  "Curacao",
  "Slovakia",
  "Fiji",
  "Puerto Rico",
  "French Guiana",
  "Cocos Islands",
  "Grenada",
  "Seychelles",
  "Anguilla",
  "Niue",
  "Monaco",
  "Antigua and Barbuda",
  "Isle of Man",
  "Saint Pierre and Miquelon",
  "Western Sahara",
  "Nauru",
  "Suriname",
  "Saint Lucia",
  "Norfolk Island",
  "Romania",
  "Christmas Island",
  "Wallis and Futuna",
  "Turks and Caicos Islands",
  "Algeria",
  "British Virgin Islands",
  "Saint Martin",
  "Macao",
  "Cook Islands",
  "Sao Tome and Principe",
  "U.S. Virgin Islands",
  "Northern Mariana Islands",
];
